<!-- Modals -->
<div *ngIf="visibility" class="cand-modal">
    <article *ngIf="visibility" [@slideInOut] class="cand-modal__overlay">
        <h1 class="cand-modal__title">
            {{ modalTitle }}
        </h1>
        <section class="cand-modal__content">
            <p class="recovery__text" [innerHTML]="content"></p>
        </section>
        <span class="cand-modal__overlay__close icon--close" (click)="close()"></span>
    </article>
    <div *ngIf="visibility" [@fadeInOut] class="cand-modal__fade" (click)="close()"></div>
</div>
